export default __webpack_public_path__ + "static/media/00.f1f1aa41.jpg";